import { render, staticRenderFns } from "./ArchitectureComponent.vue?vue&type=template&id=1fa23b2a&scoped=true&"
import script from "./ArchitectureComponent.vue?vue&type=script&lang=js&"
export * from "./ArchitectureComponent.vue?vue&type=script&lang=js&"
import style0 from "./ArchitectureComponent.vue?vue&type=style&index=0&id=1fa23b2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa23b2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
